import { type QBankStructureLevelCategory } from '@exam-management/graphql';
import { Chip, type ChipProps } from '@shared/components';

import { getQBankStructureLevelLabelByCategory } from '../../utils';

import { QBS_LEVEL_TAG_COLOR_BY_CATEGORY, QBS_LEVEL_TAG_TEXT_COLOR_BY_CATEGORY } from './constants';

export interface QBankStructureLevelTagProps extends ChipProps {
  category: QBankStructureLevelCategory;
}

export default function QBankStructureLevelTag(props: Readonly<QBankStructureLevelTagProps>) {
  const { category, ...restProps } = props;
  return (
    <Chip
      label={getQBankStructureLevelLabelByCategory(category)}
      size='small'
      sx={(theme) => ({
        bgcolor: QBS_LEVEL_TAG_COLOR_BY_CATEGORY[category],
        color: QBS_LEVEL_TAG_TEXT_COLOR_BY_CATEGORY[category],
        ...theme.typography.captionSemibold,
      })}
      {...restProps}
    />
  );
}
